
import { createContext, useMemo, useState } from "react";


const SnackBarContext = createContext();



const SnackBarProvider = ({ children }) => {

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    title: "",
    message: "",
    type: "info",
    duration: 3000
  })

  return (<SnackBarContext.Provider value={ { snackbarState, setSnackbarState}}>
    {children}
  </SnackBarContext.Provider>)

}

export { SnackBarContext, SnackBarProvider }